/*
 * Gourmet E-Liquid – blog calculators
 * Theme asset: assets/gel-calculators.js
 *
 * Powers calculator widgets pasted into article content. Shopify strips <script>
 * tags from articles, so the logic lives here. Each widget is plain HTML in the
 * article; this file finds it by ID and fills in the result.
 *
 *  - Vape tax calculator:  #gel-vape-tax-calc (v2, rendered by this script)
 *                          #gel-vt (v1 markup, still supported)
 *  - Nic shot calculator:  #gel-nc-volume etc. (existing /blogs/news/nic-shot-calculator)
 *
 * Load it on article pages only, from layout/theme.liquid just before </body>:
 *   {% if template.name == 'article' %}
 *     <script src="{{ 'gel-calculators.js' | asset_url }}" defer></script>
 *   {% endif %}
 */
(function () {
  'use strict';

  var DUTY_PER_ML = 0.22;   // £2.20 per 10ml – Vaping Products Duty from 1 October 2026
  var VAT_RATE = 0.20;      // VAT charged on top of the duty

  function money(n) {
    return '£' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function num(el, fallback) {
    var v = parseFloat(el && el.value);
    return isFinite(v) ? v : fallback;
  }
  function on(els, fn) {
    els.forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', fn);
      el.addEventListener('change', fn);
    });
  }

  /* ---------------- Vape tax calculator ---------------- */

  function vapeTax(ml) {
    var duty = ml * DUTY_PER_ML;
    var vat = duty * VAT_RATE;
    return { duty: duty, vat: vat, total: duty + vat };
  }

  function initVapeTax() {
    var root = document.getElementById('gel-vt');
    if (!root) return;
    var product = document.getElementById('gel-vt-product');
    var customWrap = document.getElementById('gel-vt-custom-wrap');
    var custom = document.getElementById('gel-vt-custom');
    var qty = document.getElementById('gel-vt-qty');
    var freq = document.getElementById('gel-vt-freq');
    var out = document.getElementById('gel-vt-result');

    function update() {
      var isCustom = product.value === 'custom';
      customWrap.style.display = isCustom ? 'block' : 'none';
      var perItem = isCustom ? num(custom, 0) : parseFloat(product.value);
      var count = Math.max(0, Math.round(num(qty, 1)));
      var ml = perItem * count;

      if (!(ml > 0)) {
        out.innerHTML = 'Enter an amount of e-liquid to see the duty.';
        return;
      }

      var t = vapeTax(ml);
      var html =
        '<p style="margin:0 0 6px;font-size:15px;">On <strong>' + +ml.toFixed(1) + 'ml</strong> of vaping liquid:</p>' +
        '<p style="margin:0;font-size:15px;">Duty ' + money(t.duty) + ' + VAT on the duty ' + money(t.vat) + '</p>' +
        '<p style="margin:8px 0 0;font-size:22px;font-weight:bold;">' + money(t.total) + ' added to the price</p>';

      var f = freq.value;
      if (f === 'week' || f === 'month') {
        var perMonth = f === 'week' ? t.total * 52 / 12 : t.total;
        var perYear = f === 'week' ? t.total * 52 : t.total * 12;
        html += '<p style="margin:10px 0 0;font-size:15px;">That\u2019s about <strong>' + money(perMonth) +
          ' a month</strong>, or <strong>' + money(perYear) + ' a year</strong>.</p>';
      }
      out.innerHTML = html;
    }

    on([product, custom, qty, freq], update);
    update();
  }


  /* ---------------- Vape tax calculator v2 (rendered by script) ----------------
   * Article markup needed:  <div id="gel-vape-tax-calc"> fallback text </div>
   * Tabs for each product type, size presets, optional current price, a basket and a
   * monthly usage estimate.
   */
  var VT_TABS = [
    { id: 'eliquid', label: 'Bottled e-liquid', unit: 'bottle',
      fields: [{ id: 'size', label: 'Bottle size', options: [['10', '10ml e-liquid or nic salt'], ['50', '50ml shortfill'], ['100', '100ml shortfill'], ['200', '200ml shortfill'], ['custom', 'Another size']] }],
      ml: function (v) { return v.size; } },
    { id: 'shortfill', label: 'Shortfill + nic shots', unit: 'mix',
      fields: [{ id: 'size', label: 'Shortfill size', options: [['50', '50ml'], ['100', '100ml'], ['200', '200ml'], ['custom', 'Another size']] },
               { id: 'shots', label: 'Nic shots added (10ml each)', type: 'number', value: 1, min: 0 }],
      ml: function (v) { return v.size + 10 * v.shots; } },
    { id: 'kit', label: 'Prefilled pod kit', unit: 'kit',
      fields: [{ id: 'size', label: 'What\u2019s in the box', options: [['2', '2ml pod'], ['12', '2ml pod + 10ml refill container'], ['10', '2ml pod + 8ml refill container'], ['7', '2ml pod + 5ml refill container'], ['8', '4-in-1 kit (4 \u00d7 2ml pods)'], ['custom', 'Another amount']] },
               { id: 'count', label: 'How many of these in the box', type: 'number', value: 1, min: 1 }],
      ml: function (v) { return v.size * v.count; } },
    { id: 'pods', label: 'Pods & refill packs', unit: 'pack',
      fields: [{ id: 'size', label: 'Pod or refill format', options: [['2', '2ml prefilled pod'], ['12', 'Refill pack: 2ml pod + 10ml container'], ['10', 'Refill pack: 2ml pod + 8ml container'], ['7', 'Refill pack: 2ml pod + 5ml container'], ['custom', 'Another amount']] },
               { id: 'count', label: 'Pods or packs in each box', type: 'number', value: 1, min: 1 }],
      ml: function (v) { return v.size * v.count; } },
    { id: 'shots', label: 'Nic shots', unit: 'shot',
      fields: [{ id: 'size', label: 'Shot size', options: [['10', '10ml nic shot']] }],
      ml: function (v) { return v.size; } }
  ];

  var VT_CSS = '.gelvt{border:1px solid #ddd;border-radius:8px;padding:18px;margin:24px 0;background:#fafafa;max-width:640px}' +
    '.gelvt *{box-sizing:border-box}.gelvt-tabs{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:14px}' +
    '.gelvt-tab{border:1px solid #2e7d32;background:#fff;color:#2e7d32;border-radius:999px;padding:6px 12px;font-size:14px;cursor:pointer;font-family:inherit}' +
    '.gelvt-tab[aria-selected=true]{background:#2e7d32;color:#fff}' +
    '.gelvt-row{display:flex;flex-wrap:wrap;gap:12px;margin-bottom:12px}.gelvt-f{flex:1 1 180px}' +
    '.gelvt label{display:block;font-weight:bold;font-size:14px;margin-bottom:4px}' +
    '.gelvt input,.gelvt select{width:100%;padding:8px;font-size:16px;font-family:inherit;border:1px solid #bbb;border-radius:4px;background:#fff}' +
    '.gelvt-res{background:#e8f5e9;border-left:4px solid #2e7d32;padding:12px 14px;margin:6px 0 12px}' +
    '.gelvt-res p{margin:0 0 4px}.gelvt-big{font-size:22px;font-weight:bold}' +
    '.gelvt-btn{background:#2e7d32;color:#fff;border:0;border-radius:4px;padding:9px 14px;font-size:15px;cursor:pointer;font-family:inherit}' +
    '.gelvt-link{background:none;border:0;color:#b3261e;cursor:pointer;font-size:13px;padding:0 4px;font-family:inherit}' +
    '.gelvt h4{margin:16px 0 6px;font-size:16px}.gelvt table{width:100%;border-collapse:collapse;font-size:14px}' +
    '.gelvt td{padding:5px 4px;border-bottom:1px solid #e3e3e3;vertical-align:top}.gelvt td.n{text-align:right;white-space:nowrap}' +
    '.gelvt small{display:block;color:#555;font-size:12px;margin-top:10px}';

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initVapeTaxV2() {
    var host = document.getElementById('gel-vape-tax-calc');
    if (!host) return;
    if (!document.getElementById('gelvt-css')) {
      var st = document.createElement('style'); st.id = 'gelvt-css'; st.textContent = VT_CSS; document.head.appendChild(st);
    }
    var state = { tab: 0, basket: [] };

    host.className = 'gelvt';
    host.innerHTML =
      '<div class="gelvt-tabs" role="tablist">' + VT_TABS.map(function (t, i) {
        return '<button type="button" class="gelvt-tab" role="tab" data-i="' + i + '" aria-selected="' + (i === 0) + '">' + esc(t.label) + '</button>';
      }).join('') + '</div>' +
      '<div class="gelvt-fields"></div>' +
      '<div class="gelvt-res" aria-live="polite"></div>' +
      '<button type="button" class="gelvt-btn gelvt-add">+ Add to basket</button>' +
      '<div class="gelvt-basket"></div>' +
      '<h4>What it adds over a month</h4>' +
      '<div class="gelvt-row"><div class="gelvt-f"><label for="gelvt-daily">E-liquid you vape per day (ml)</label>' +
      '<input id="gelvt-daily" type="number" min="0" step="0.5" value="2" inputmode="decimal"></div></div>' +
      '<div class="gelvt-usage gelvt-res" aria-live="polite"></div>' +
      '<small>Estimates only. The duty is \u00a32.20 per 10ml at any nicotine strength, including 0mg, with VAT charged on top, so about \u00a32.64 per 10ml is added. Products imported before 1 October 2026 may still be sold without the duty until 31 March 2027. Shelf prices depend on how much of the duty each brand and retailer passes on.</small>';

    var fieldsEl = host.querySelector('.gelvt-fields'), resEl = host.querySelector('.gelvt-res'),
        basketEl = host.querySelector('.gelvt-basket'), usageEl = host.querySelector('.gelvt-usage'),
        dailyEl = host.querySelector('#gelvt-daily');

    function renderFields() {
      var t = VT_TABS[state.tab], html = '<div class="gelvt-row">';
      t.fields.forEach(function (f) {
        var id = 'gelvt-' + f.id;
        html += '<div class="gelvt-f"><label for="' + id + '">' + esc(f.label) + '</label>';
        if (f.options) {
          html += '<select id="' + id + '">' + f.options.map(function (o) { return '<option value="' + o[0] + '">' + esc(o[1]) + '</option>'; }).join('') + '</select>';
        } else {
          html += '<input id="' + id + '" type="number" min="' + f.min + '" step="1" value="' + f.value + '" inputmode="numeric">';
        }
        html += '</div>';
      });
      html += '</div><div class="gelvt-row">' +
        '<div class="gelvt-f gelvt-custom" style="display:none"><label for="gelvt-custom">Amount of e-liquid (ml)</label><input id="gelvt-custom" type="number" min="0" step="1" value="30" inputmode="decimal"></div>' +
        '<div class="gelvt-f"><label for="gelvt-qty">Quantity</label><input id="gelvt-qty" type="number" min="1" step="1" value="1" inputmode="numeric"></div>' +
        '<div class="gelvt-f"><label for="gelvt-price">Current price each (optional, \u00a3)</label><input id="gelvt-price" type="number" min="0" step="0.01" placeholder="e.g. 4.99" inputmode="decimal"></div></div>';
      fieldsEl.innerHTML = html;
      fieldsEl.querySelectorAll('input,select').forEach(function (el) {
        el.addEventListener('input', update); el.addEventListener('change', update);
      });
      if (state.tab === 1) { // shortfill: default shots to match the size
        var sizeEl = fieldsEl.querySelector('#gelvt-size'), shotsEl = fieldsEl.querySelector('#gelvt-shots');
        sizeEl.addEventListener('change', function () {
          var m = { '50': 1, '100': 2, '200': 4 }[sizeEl.value]; if (m) { shotsEl.value = m; update(); }
        });
      }
      update();
    }

    function current() {
      var t = VT_TABS[state.tab], v = {};
      var sizeEl = fieldsEl.querySelector('#gelvt-size'), customWrap = fieldsEl.querySelector('.gelvt-custom');
      var isCustom = sizeEl.value === 'custom';
      customWrap.style.display = isCustom ? 'block' : 'none';
      v.size = isCustom ? num(fieldsEl.querySelector('#gelvt-custom'), 0) : parseFloat(sizeEl.value);
      t.fields.forEach(function (f) { if (!f.options) v[f.id] = Math.max(f.min, Math.round(num(fieldsEl.querySelector('#gelvt-' + f.id), f.value))); });
      var perItem = Math.max(0, t.ml(v));
      var qty = Math.max(1, Math.round(num(fieldsEl.querySelector('#gelvt-qty'), 1)));
      var priceRaw = fieldsEl.querySelector('#gelvt-price').value;
      var price = priceRaw === '' ? null : Math.max(0, parseFloat(priceRaw));
      var desc = isCustom ? perItem + 'ml' : sizeEl.options[sizeEl.selectedIndex].text;
      if (t.id === 'shortfill') desc += ' + ' + v.shots + ' shot' + (v.shots === 1 ? '' : 's');
      if ((t.id === 'kit' || t.id === 'pods') && v.count > 1) desc += ' \u00d7 ' + v.count;
      return { label: t.label + ': ' + desc, ml: perItem, qty: qty, price: isFinite(price) ? price : null, unit: t.unit };
    }

    function update() {
      var c = current();
      if (!(c.ml > 0)) { resEl.innerHTML = '<p>Enter an amount of e-liquid to see the duty.</p>'; return; }
      var t = vapeTax(c.ml), line = t.total * c.qty;
      var html = '<p class="gelvt-big">' + money(t.total) + ' added per ' + c.unit + '</p>' +
        '<p>' + +c.ml.toFixed(1) + 'ml of taxable liquid: duty ' + money(t.duty) + ' + VAT on the duty ' + money(t.vat) + '</p>';
      if (c.qty > 1) html += '<p>For ' + c.qty + ': <strong>' + money(line) + '</strong></p>';
      if (c.price !== null) html += '<p>At ' + money(c.price) + ' now, the full duty would take it to about <strong>' + money(c.price + t.total) + '</strong> each.</p>';
      resEl.innerHTML = html;
    }

    function renderBasket() {
      if (!state.basket.length) { basketEl.innerHTML = ''; return; }
      var total = 0, ml = 0;
      var rows = state.basket.map(function (b, i) {
        var t = vapeTax(b.ml), line = t.total * b.qty; total += line; ml += b.ml * b.qty;
        return '<tr><td>' + esc(b.label) + (b.qty > 1 ? ' \u00d7 ' + b.qty : '') + '</td><td class="n">' + money(line) +
          '</td><td class="n"><button type="button" class="gelvt-link" data-rm="' + i + '" aria-label="Remove">Remove</button></td></tr>';
      }).join('');
      basketEl.innerHTML = '<h4>Your basket</h4><table>' + rows +
        '<tr><td><strong>Total tax added (' + +ml.toFixed(1) + 'ml)</strong></td><td class="n"><strong>' + money(total) + '</strong></td><td></td></tr></table>';
      basketEl.querySelectorAll('[data-rm]').forEach(function (b) {
        b.addEventListener('click', function () { state.basket.splice(+b.getAttribute('data-rm'), 1); renderBasket(); });
      });
    }

    function updateUsage() {
      var d = num(dailyEl, 0);
      if (!(d > 0)) { usageEl.innerHTML = '<p>Enter how many ml you vape a day.</p>'; return; }
      var perMl = vapeTax(1).total;
      usageEl.innerHTML = '<p>About <strong>' + money(perMl * d * 30) + ' a month</strong>, or <strong>' + money(perMl * d * 365) + ' a year</strong>, in duty and VAT at ' + d + 'ml a day.</p>';
    }

    host.querySelectorAll('.gelvt-tab').forEach(function (b) {
      b.addEventListener('click', function () {
        state.tab = +b.getAttribute('data-i');
        host.querySelectorAll('.gelvt-tab').forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
        renderFields();
      });
    });
    host.querySelector('.gelvt-add').addEventListener('click', function () {
      var c = current(); if (c.ml > 0) { state.basket.push(c); renderBasket(); }
    });
    on([dailyEl], updateUsage);
    renderFields(); updateUsage();
  }

  /* ---------------- Nic shot calculator ---------------- */

  // How many 10ml shots of strength `shot` (mg/ml) to add to `vol` ml of 0mg shortfill
  // to reach `target` mg/ml.
  function shotsNeeded(vol, shot, target) {
    if (target <= 0 || target >= shot) return null;
    return (target * vol) / (10 * (shot - target));
  }
  function strengthWith(vol, shot, n) { return (shot * 10 * n) / (vol + 10 * n); }

  function initNicShot() {
    var volEl = document.getElementById('gel-nc-volume');
    if (!volEl) return;
    var shotEl = document.getElementById('gel-nc-shot');
    var targetEl = document.getElementById('gel-nc-target');
    var bottleEl = document.getElementById('gel-nc-bottle');
    var out = document.getElementById('gel-nc-result');
    if (!out) return;

    function update() {
      var vol = num(volEl, 0), shot = num(shotEl, 18), target = num(targetEl, 0), bottle = num(bottleEl, 0);
      if (!(vol > 0)) { out.innerHTML = 'Enter the amount of shortfill in your bottle.'; return; }
      if (!(target > 0)) { out.innerHTML = 'Enter the nicotine strength you want, for example 3.'; return; }
      if (target >= shot) {
        out.innerHTML = 'The strength you want must be lower than the shot strength (' + shot + 'mg/ml).';
        return;
      }

      var exact = shotsNeeded(vol, shot, target);
      var n = Math.max(1, Math.round(exact));
      var total = vol + 10 * n;
      var strength = strengthWith(vol, shot, n);

      var html =
        '<p style="margin:0;font-size:22px;font-weight:bold;">Add ' + n + ' nic shot' + (n === 1 ? '' : 's') + '</p>' +
        '<p style="margin:6px 0 0;font-size:15px;">That makes ' + +total.toFixed(1) + 'ml at about <strong>' +
        strength.toFixed(1) + 'mg/ml</strong>.</p>';

      if (Math.abs(exact - n) > 0.05) {
        var alt = exact > n ? n + 1 : n - 1;
        if (alt >= 1) {
          html += '<p style="margin:6px 0 0;font-size:14px;">With ' + alt + ' shot' + (alt === 1 ? '' : 's') +
            ' you\u2019d get about ' + strengthWith(vol, shot, alt).toFixed(1) + 'mg/ml.</p>';
        }
      }
      if (bottle > 0) {
        if (total > bottle) {
          html += '<p style="margin:8px 0 0;font-size:14px;color:#b3261e;"><strong>This won\u2019t fit:</strong> ' +
            +total.toFixed(1) + 'ml is more than your ' + +bottle.toFixed(1) + 'ml bottle.</p>';
        } else {
          html += '<p style="margin:8px 0 0;font-size:14px;">Fits your ' + +bottle.toFixed(1) + 'ml bottle with ' +
            +(bottle - total).toFixed(1) + 'ml to spare.</p>';
        }
      }
      out.innerHTML = html;
    }

    on([volEl, shotEl, targetEl, bottleEl], update);
    update();
  }

  function init() { initVapeTax(); initVapeTaxV2(); initNicShot(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // exposed for testing
  window.GELCalc = { vapeTax: vapeTax, shotsNeeded: shotsNeeded, strengthWith: strengthWith };
})();